export enum StaffInvoiceDateField {
  CREATED_AT = 'createdAt',
  INVOICE_DATE = 'invoiceDate',
}
